// extracted by mini-css-extract-plugin
export default {"wrapper":"ViTri_wrapper__Woq2c","container":"ViTri_container__kgPSp","content":"ViTri_content__T1UOj"};